import {Method} from '../types/http/Method';

export default class HttpClient {
    private static setupRequest(method: Method, url: string, data: any) {
        const requestUrl = url.startsWith('/') ? `${process.env.REACT_APP_API_URL}${url}` : url;
        const controller = new AbortController();
        setTimeout(() => controller.abort(), 15000);

        const options: RequestInit = {
            method,
            signal: controller.signal,
            body: data ? JSON.stringify(data) : undefined
        };

        return {requestUrl, options};
    }

    static async loadData<T>(
        method: Method,
        url: string,
        data: any = null,
    ): Promise<T> {
        const {requestUrl, options} = this.setupRequest(method, url, data);
        options.headers = {'Content-Type': 'application/json'};

        const response = await fetch(requestUrl, options);
        if(!response.ok)
            throw new Error(response.statusText);

        return response.json();
    }

    static async loadText(method: Method, url: string, data: any = null): Promise<string> {
        const {requestUrl, options} = this.setupRequest(method, url, data);
        const response = await fetch(requestUrl, options);
        if(!response.ok)
            throw new Error(response.statusText);

        return response.text();
    }
}
